import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@api";
import "./CreatePageWizard.css";
import FullPagePreview from "../Components/FullPagePreview.jsx";
import Step2Look from "../Shared/Steps/Step2Look.jsx";
import Step3Links from "../Shared/Steps/Step3Links.jsx";
import Step1CreateHomepage from "../Shared/Steps/Step1CreateHomepage.jsx";
import Step2DefaultHomepageContent from "../Organizations/Default/Steps/Step2DefaultHomepageContent.jsx";
import Step2FabHomepageContent from "../Organizations/Fab/Steps/Step2FabHomepageContent.jsx";
import { useAuth } from "../../../../context/AuthContext.jsx"



function slugify(input = "") {
  return input
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 40);
}

function CreatePageWizard() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [params] = useSearchParams();
  const orgId = params.get("orgId");
  const [step, setStep] = useState(1);
  const [showFullPreview, setShowFullPreview] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const previewInnerRef = useRef(null);
  const [previewScaledHeight, setPreviewScaledHeight] = useState(0);

  // STEP 1 TEMPLATE
  const [templateId, setTemplateId] = useState("default-homepage");

  // STEP 2 CONTENT (shared/default fields)
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [headline, setHeadline] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const [registrationLabel, setRegistrationLabel] = useState("Register");
  const [registrationUrl, setRegistrationUrl] = useState("");
  const [slugTouched, setSlugTouched] = useState(false);
  const [slugStatus, setSlugStatus] = useState({ checking: false, available: null, message: "" });
  const [existingLogoUrl, setExistingLogoUrl] = useState("");
  const [existingCoverUrl, setExistingCoverUrl] = useState("");
  const [removeLogo, setRemoveLogo] = useState(false);
  const [removeCover, setRemoveCover] = useState(false);

  // STEP 2 CONTENT (FAB fields)
  const [heroTitle, setHeroTitle] = useState("");
  const [heroSubtitle, setHeroSubtitle] = useState("");
  const [heroButtonLabel, setHeroButtonLabel] = useState("EXPLORE");
  const [heroButtonLink, setHeroButtonLink] = useState("");
  const [introText, setIntroText] = useState("");
  const [sectionTwoText, setSectionTwoText] = useState("");
  const [sectionThreeText, setSectionThreeText] = useState("");
  const [sectionFourText, setSectionFourText] = useState("");
  const [galleryText, setGalleryText] = useState("");

  const [heroImageFile, setHeroImageFile] = useState(null);
  const [secondHeroImageFile, setSecondHeroImageFile] = useState(null);
  const [thirdHeroImageFile, setThirdHeroImageFile] = useState(null);
  const [fourthHeroImageFile, setFourthHeroImageFile] = useState(null);

  const [existingHeroImageUrl, setExistingHeroImageUrl] = useState("");
  const [existingSecondHeroImageUrl, setExistingSecondHeroImageUrl] = useState("");
  const [existingThirdHeroImageUrl, setExistingThirdHeroImageUrl] = useState("");
  const [existingFourthHeroImageUrl, setExistingFourthHeroImageUrl] = useState("");

  const [removeHeroImage, setRemoveHeroImage] = useState(false);
  const [removeSecondHeroImage, setRemoveSecondHeroImage] = useState(false);
  const [removeThirdHeroImage, setRemoveThirdHeroImage] = useState(false);
  const [removeFourthHeroImage, setRemoveFourthHeroImage] = useState(false);

  // STEP 3 LOOK
  const [themeMode, setThemeMode] = useState("light");
  const [primaryColor, setPrimaryColor] = useState("#111111");
  const [accentColor, setAccentColor] = useState("#111111");

  // STEP 4 LINKS
  const [about, setAbout] = useState("");
  const [instagram, setInstagram] = useState("");
  const [facebook, setFacebook] = useState("");
  const [twitter, setTwitter] = useState("");
  const [youtube, setYoutube] = useState("");
  const [email, setEmail] = useState("");

  const [templateAccess, setTemplateAccess] = useState([]);


  // // STEP 1 BASIC
  // const [name, setName] = useState("");
  // const [slug, setSlug] = useState("");
  // const [headline, setHeadline] = useState("");
  // const [logoFile, setLogoFile] = useState(null);
  // const [coverFile, setCoverFile] = useState(null);
  // const [registrationLabel, setRegistrationLabel] = useState("Register");
  // const [registrationUrl, setRegistrationUrl] = useState("");
  // const [slugTouched, setSlugTouched] = useState(false);
  // const [slugStatus, setSlugStatus] = useState({ checking: false, available: null, message: "" });
  // const [existingLogoUrl, setExistingLogoUrl] = useState("");
  // const [existingCoverUrl, setExistingCoverUrl] = useState("");
  // const [removeLogo, setRemoveLogo] = useState(false);
  // const [removeCover, setRemoveCover] = useState(false);
  // // STEP 2 LOOK
  // const [templateId, setTemplateId] = useState("default-homepage");
  // const [themeMode, setThemeMode] = useState("dark"); 
  // const [primaryColor, setPrimaryColor] = useState("#111111");
  // const [accentColor, setAccentColor] = useState("");

  // // STEP 3 ABOUT & SOCIAL
  // const [about, setAbout] = useState("");
  // const [instagram, setInstagram] = useState("");
  // const [facebook, setFacebook] = useState("");
  // const [twitter, setTwitter] = useState("");
  // const [youtube, setYoutube] = useState("");
  // const [email, setEmail] = useState("");



  useEffect(() => {
    if (!slugTouched) setSlug(slugify(name));
  }, [name, slugTouched]);







  useEffect(() => {
    let alive = true;
    const s = slug.trim();
    if (!s) {
      setSlugStatus({ checking: false, available: null, message: "" });
      return;
    }
    setSlugStatus((p) => ({ ...p, checking: true, message: "" }));
    const t = setTimeout(async () => {
      try {
        const res = await api.get("/api/onboarding/organizations/slug-check", {
          params: { slug: s, orgId: orgId || undefined },
        });
        if (!alive) return;
        const ok = Boolean(res.data?.available);
        setSlugStatus({
          checking: false,
          available: ok,
          message: ok ? "Available" : "Taken",
        });
      } catch (e) {
        if (!alive) return;
        if (e?.code === "ERR_CANCELED") return; // ✅ ignore canceled debounce requests
        setSlugStatus({
          checking: false,
          available: null,
          message: "Could not verify",
        });
      }
    }, 350);

    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [slug]);

  useEffect(() => {
    let alive = true;

    const loadOrganization = async () => {
      if (!orgId) return;

      try {
        const res = await api.get(`/api/organizations/${orgId}`);
        if (!alive) return;

        const orgTemplateAccess = res.data?.organization?.templateAccess || [];
        setTemplateAccess(orgTemplateAccess);
      } catch (error) {
        console.error("Failed to load organization template access", error);
      }
    };

    loadOrganization();

    return () => {
      alive = false;
    };
  }, [orgId]);




  // useEffect(() => {
  //   let alive = true;
  //   const load = async () => {
  //     if (!orgId) return;
  //     try {
  //       const res = await api.get(`/api/onboarding/organizations/${orgId}`);
  //       if (!alive) return;
  //       const o = res.data?.organization;
  //       if (!o) return;
  //       setHasPage(!!o.page_id);
  //       setName(o.name || "");
  //       setSlug(o.slug || "");
  //       setSlugTouched(Boolean(o.slug));
  //       setTemplateId(o.template_id || "default-homepage");
  //       setThemeMode(o.theme_mode || "dark");
  //       setPrimaryColor(o.primary_color || "#111111");
  //       setAccentColor(o.accent_color || "#111111");
  //       setAbout(o.about || "");
  //       setTwitter(o.twitter_url || "");
  //       setYoutube(o.youtube_url || "");
  //       setRegistrationUrl(o.registration_url || "");
  //       setHeadline(o.headline || "");
  //       setRegistrationLabel(o.registration_label || "Register");
  //       setInstagram(o.instagram_url || "");
  //       setFacebook(o.facebook_url || "");
  //       setEmail(o.contact_email || "");
  //       setExistingLogoUrl(o.logo_url || "");
  //       setExistingCoverUrl(o.cover_url || "");
  //     } catch (e) {
  //       console.error("Failed to load org for edit", e);
  //     }
  //   };
  //   load();
  //   return () => { alive = false; };
  // }, [orgId]);

  // const urlPreview = useMemo(() => {
  //   const s = slug.trim() || "your-link";
  //   return `sportinghip.com/${s}`;
  // }, [slug]);

  const coverPreviewUrl = useMemo(() => {
    if (coverFile) return URL.createObjectURL(coverFile);
    return "";
  }, [coverFile]);

  const logoPreviewUrl = useMemo(() => {
    if (logoFile) return URL.createObjectURL(logoFile);
    return "";
  }, [logoFile]);



  const canNextStep1 =
    Boolean(templateId) &&
    name.trim().length >= 2 &&
    slug.trim().length >= 2 &&
    slugStatus.available === true;

  const canNextStep2 = true;

  const canNextStep3 = Boolean(primaryColor);
  const canNextStep4 = true;

  const canPublish =
    canNextStep1 &&
    canNextStep2 &&
    canNextStep3 &&
    canNextStep4 &&
    slugStatus.available === true &&
    !submitting;



  const next = () => setStep((s) => Math.min(4, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));



  const handlePublish = async () => {
    if (!canPublish) return;
    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("name", name.trim());
      formData.append("slug", slug.trim());
      formData.append("title", title.trim() || "");
      formData.append("headline", headline.trim());
      formData.append("registration_label", registrationLabel.trim() || "Register");
      formData.append("about", about.trim() || "");
      formData.append("template_id", templateId);
      formData.append("theme_mode", themeMode);
      formData.append("primary_color", primaryColor);
      formData.append("instagram_url", instagram.trim() || "");
      formData.append("facebook_url", facebook.trim() || "");
      formData.append("contact_email", email.trim() || "");
      formData.append("registration_url", registrationUrl.trim() || "");
      formData.append("accent_color", accentColor.trim() || "");
      formData.append("twitter_url", twitter.trim() || "");
      formData.append("youtube_url", youtube.trim() || "");
      formData.append("remove_logo", removeLogo ? "true" : "false");
      formData.append("remove_cover", removeCover ? "true" : "false");
      if (logoFile) {
        formData.append("logo", logoFile);
      }
      if (coverFile) {
        formData.append("cover", coverFile);
      }
      const res = await api.post("/api/onboarding/organizations", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const savedOrgId = res.data?.organization?.id || res.data?.org_id || orgId;
      await checkAuth();
      sessionStorage.setItem(
        "dashboard_success_message",
        "Page published successfully."
      );

      if (savedOrgId) {
        navigate(`/dashboard/organizations/${savedOrgId}`, { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (e) {
      console.error("Create org failed", e);
      setSubmitting(false);
      alert("Could not create your page. Please try again.");
    }
  };




  // };
  const canGoToStep = (targetStep) => {
    if (targetStep === 1) return true;
    if (targetStep === 2) return canNextStep1;
    if (targetStep === 3) return canNextStep1 && canNextStep2;
    if (targetStep === 4) return canNextStep1 && canNextStep2 && canNextStep3;
    return false;
  };
  const resolvedLogoUrl = logoPreviewUrl || (removeLogo ? "" : existingLogoUrl) || "";
  const resolvedCoverUrl = coverPreviewUrl || (removeCover ? "" : existingCoverUrl) || "";



  const resolvedHeroImageUrl = useMemo(() => {
    if (heroImageFile) return URL.createObjectURL(heroImageFile);
    return removeHeroImage ? "" : existingHeroImageUrl || "";
  }, [heroImageFile, removeHeroImage, existingHeroImageUrl]);

  const resolvedSecondHeroImageUrl = useMemo(() => {
    if (secondHeroImageFile) return URL.createObjectURL(secondHeroImageFile);
    return removeSecondHeroImage ? "" : existingSecondHeroImageUrl || "";
  }, [secondHeroImageFile, removeSecondHeroImage, existingSecondHeroImageUrl]);

  const resolvedThirdHeroImageUrl = useMemo(() => {
    if (thirdHeroImageFile) return URL.createObjectURL(thirdHeroImageFile);
    return removeThirdHeroImage ? "" : existingThirdHeroImageUrl || "";
  }, [thirdHeroImageFile, removeThirdHeroImage, existingThirdHeroImageUrl]);

  const resolvedFourthHeroImageUrl = useMemo(() => {
    if (fourthHeroImageFile) return URL.createObjectURL(fourthHeroImageFile);
    return removeFourthHeroImage ? "" : existingFourthHeroImageUrl || "";
  }, [fourthHeroImageFile, removeFourthHeroImage, existingFourthHeroImageUrl]);

  const previewData = useMemo(() => {
    if (templateId === "fab-homepage") {
      return {
        organization: {
          name: name?.trim() || "Your Organization",
          slug: slug?.trim() || "your-page",
          instagram_url: instagram?.trim() || "",
          facebook_url: facebook?.trim() || "",
          twitter_url: twitter?.trim() || "",
          youtube_url: youtube?.trim() || "",
          contact_email: email?.trim() || "",
        },
        page: {
          template_id: "fab-homepage",
          content: {
            hero_title: heroTitle?.trim() || "FAB",
            hero_subtitle:
              heroSubtitle?.trim() || "Competition . Community . Camaraderie",
            hero_button_label: heroButtonLabel?.trim() || "EXPLORE",
            hero_button_link: heroButtonLink?.trim() || "",
            hero_image_url: resolvedHeroImageUrl || "",
            intro_text: introText?.trim() || "",
            section_two_text: sectionTwoText?.trim() || "",
            section_three_text: sectionThreeText?.trim() || "",
            section_four_lines: sectionFourText
              ? sectionFourText.split("\n").map((line) => line.trim()).filter(Boolean)
              : [],
            gallery_images: galleryText
              ? galleryText.split("\n").map((line) => line.trim()).filter(Boolean)
              : [],
            second_hero_image_url: resolvedSecondHeroImageUrl || "",
            third_hero_image_url: resolvedThirdHeroImageUrl || "",
            fourth_hero_image_url: resolvedFourthHeroImageUrl || "",
          },
        },
        settings: {
          theme_mode: themeMode || "dark",
          primary_color: primaryColor || "#111111",
          accent_color: accentColor || "",
        },
      };
    }

    return {
      organization: {
        name: name?.trim() || "Your Organization",
        slug: slug?.trim() || "your-page",
        instagram_url: instagram?.trim() || "",
        facebook_url: facebook?.trim() || "",
        twitter_url: twitter?.trim() || "",
        youtube_url: youtube?.trim() || "",
        contact_email: email?.trim() || "",
      },
      page: {
        template_id: "default-homepage",
        content: {
          title: title?.trim() || "",
          headline: headline?.trim() || "Welcome to our page.",
          registration_label: registrationLabel?.trim() || "Register",
          registration_url: registrationUrl?.trim() || "",
          cover_url: removeCover ? "" : existingCoverUrl || "",
        },
      },
      settings: {
        theme_mode: themeMode || "dark",
        primary_color: primaryColor || "#ffffff",
        accent_color: accentColor || "#d4af37",
        logo_url: resolvedLogoUrl || "",
      },
    };
  }, [
    templateId,
    name,
    slug,
    title,
    headline,
    about,
    registrationLabel,
    registrationUrl,
    instagram,
    facebook,
    twitter,
    youtube,
    email,
    themeMode,
    primaryColor,
    accentColor,
    resolvedCoverUrl,
    resolvedLogoUrl,
    heroTitle,
    heroSubtitle,
    heroButtonLabel,
    heroButtonLink,
    introText,
    sectionTwoText,
    sectionThreeText,
    sectionFourText,
    galleryText,
    resolvedHeroImageUrl,
    resolvedSecondHeroImageUrl,
    resolvedThirdHeroImageUrl,
    resolvedFourthHeroImageUrl,
  ]);

  const missingStep2Fields = [];
  if (!name.trim()) missingStep2Fields.push("organization name");
  if (slug.trim().length < 2) missingStep2Fields.push("slug");
  if (slugStatus.available === false) missingStep2Fields.push("an available slug");

  const step2ErrorMessage = slugStatus.checking
    ? "Checking slug..."
    : missingStep2Fields.length
      ? `Please enter your Sportinghip Link`
      : "";

  useLayoutEffect(() => {
    const el = previewInnerRef.current;
    if (!el) return;

    const frame = el.closest(".cpw-preview-frame");
    const styles = frame ? getComputedStyle(frame) : null;
    const scale = styles ? Number(styles.getPropertyValue("--preview-scale")) || 0.44 : 0.44;

    const updateHeight = () => {
      const fullHeight = el.scrollHeight;
      setPreviewScaledHeight(fullHeight * scale);
    };

    updateHeight();

    const ro = new ResizeObserver(updateHeight);
    ro.observe(el);

    return () => ro.disconnect();
  }, [previewData]);


  return (
    <div className="cpw-page">
      <div className="cpw-shell">
        <div className="cpw-top">
          <div className="cpw-title">
            <h1>Create your page</h1>
            <p>Step {step} of 4</p>
          </div>

          <div className="cpw-progress">
            {[1, 2, 3, 4].map((n) => (
              <button
                key={n}
                type="button"
                className={`dot ${step >= n ? "on" : ""}`}
                onClick={() => {
                  if (canGoToStep(n)) setStep(n);
                }}
                disabled={!canGoToStep(n)}
                aria-label={`Go to step ${n}`}
              />
            ))}
          </div>

        </div>

        <div className="cpw-grid">


          {/* LEFT: PREVIEW */}
          <div className="cpw-preview">
            <div className="cpw-preview-toolbar">
              <button
                type="button"
                className="cpw-preview-open"
                onClick={() => setShowFullPreview(true)}
              >
                Full preview
              </button>
            </div>

            <div className={`cpw-preview-frame ${themeMode === "light" ? "light" : "dark"}`}>
              <div className="cpw-preview-scroll">
                <div
                  className="cpw-preview-content"
                  style={{ height: previewScaledHeight ? `${previewScaledHeight}px` : "auto" }}
                >
                  <div className="cpw-preview-scale" ref={previewInnerRef}>
                    <FullPagePreview pageData={previewData} />
                  </div>
                </div>
              </div>
            </div>

            <div className="preview-note">
              This is a preview. You can change everything later.
            </div>
          </div>







          {/* RIGHT: FORM */}
          <div className="cpw-form">
            {step === 1 && (
              <Step1CreateHomepage
                templateId={templateId}
                setTemplateId={setTemplateId}
                name={name}
                setName={setName}
                slug={slug}
                setSlug={setSlug}
                slugTouched={slugTouched}
                setSlugTouched={setSlugTouched}
                slugStatus={slugStatus}
                templateAccess={templateAccess}
              />
            )}

            {step === 2 && templateId === "default-homepage" && (
              <Step2DefaultHomepageContent
                title={title}
                setTitle={setTitle}
                headline={headline}
                setHeadline={setHeadline}
                coverFile={coverFile}
                setCoverFile={setCoverFile}
                logoFile={logoFile}
                setLogoFile={setLogoFile}
                existingLogoUrl={existingLogoUrl}
                existingCoverUrl={existingCoverUrl}
                registrationUrl={registrationUrl}
                setRegistrationUrl={setRegistrationUrl}
                registrationLabel={registrationLabel}
                setRegistrationLabel={setRegistrationLabel}
                removeLogo={removeLogo}
                setRemoveLogo={setRemoveLogo}
                removeCover={removeCover}
                setRemoveCover={setRemoveCover}
              />
            )}

            {step === 2 && templateId === "fab-homepage" && (
              <Step2FabHomepageContent
                heroTitle={heroTitle}
                setHeroTitle={setHeroTitle}
                heroSubtitle={heroSubtitle}
                setHeroSubtitle={setHeroSubtitle}
                heroButtonLabel={heroButtonLabel}
                setHeroButtonLabel={setHeroButtonLabel}
                heroButtonLink={heroButtonLink}
                setHeroButtonLink={setHeroButtonLink}
                heroImageFile={heroImageFile}
                setHeroImageFile={setHeroImageFile}
                secondHeroImageFile={secondHeroImageFile}
                setSecondHeroImageFile={setSecondHeroImageFile}
                thirdHeroImageFile={thirdHeroImageFile}
                setThirdHeroImageFile={setThirdHeroImageFile}
                fourthHeroImageFile={fourthHeroImageFile}
                setFourthHeroImageFile={setFourthHeroImageFile}
                introText={introText}
                setIntroText={setIntroText}
                sectionTwoText={sectionTwoText}
                setSectionTwoText={setSectionTwoText}
                sectionThreeText={sectionThreeText}
                setSectionThreeText={setSectionThreeText}
                sectionFourText={sectionFourText}
                setSectionFourText={setSectionFourText}
                galleryText={galleryText}
                setGalleryText={setGalleryText}
                existingHeroImageUrl={existingHeroImageUrl}
                existingSecondHeroImageUrl={existingSecondHeroImageUrl}
                existingThirdHeroImageUrl={existingThirdHeroImageUrl}
                existingFourthHeroImageUrl={existingFourthHeroImageUrl}
                removeHeroImage={removeHeroImage}
                setRemoveHeroImage={setRemoveHeroImage}
                removeSecondHeroImage={removeSecondHeroImage}
                setRemoveSecondHeroImage={setRemoveSecondHeroImage}
                removeThirdHeroImage={removeThirdHeroImage}
                setRemoveThirdHeroImage={setRemoveThirdHeroImage}
                removeFourthHeroImage={removeFourthHeroImage}
                setRemoveFourthHeroImage={setRemoveFourthHeroImage}
              />
            )}

            {step === 3 && (
              <Step2Look
                primaryColor={primaryColor}
                setPrimaryColor={setPrimaryColor}
                themeMode={themeMode}
                setThemeMode={setThemeMode}
                accentColor={accentColor}
                setAccentColor={setAccentColor}
              />
            )}

            {step === 4 && (
              <Step3Links
                instagram={instagram}
                setInstagram={setInstagram}
                facebook={facebook}
                setFacebook={setFacebook}
                twitter={twitter}
                setTwitter={setTwitter}
                youtube={youtube}
                setYoutube={setYoutube}
                email={email}
                setEmail={setEmail}
              />
            )}

            {/* FOOTER NAV */}
            <div className="cpw-nav">
              <button type="button" className="ghost" onClick={() => {
                if (step === 1) {
                  if (orgId) navigate(`/dashboard/organizations/${orgId}`);
                  else navigate("/dashboard/dashboard-start");
                } else {
                  back();
                }
              }}>
                Back
              </button>
              {step < 4 ? (
                <div
                  className={`cpw-next-wrap ${step === 2 && !canNextStep2 ? "show-tooltip" : ""}`}
                  data-tooltip={step === 2 && !canNextStep2 ? step2ErrorMessage : ""}
                >
                  <button
                    type="button"
                    className="next"
                    onClick={next}
                    disabled={
                      (step === 1 && !canNextStep1) ||
                      (step === 2 && !canNextStep2) ||
                      (step === 3 && !canNextStep3)
                    }
                  >
                    Next
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  className="next"
                  onClick={handlePublish}
                  disabled={!canPublish}
                >
                  {submitting ? "Creating…" : "Publish"}
                </button>
              )}
            </div>
          </div>


        </div>

        <div className="cpw-bottom">
          <button
            type="button"
            className="linkish"
            onClick={() => {
              navigate("/dashboard/dashboard-start");
            }}
          >
            Cancel
          </button>
        </div>

      </div>

      {showFullPreview && (
        <div className="cpw-modal-backdrop" onClick={() => setShowFullPreview(false)}>
          <div className="cpw-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="cpw-modal-close"
              onClick={() => setShowFullPreview(false)}
              aria-label="Close"
            >
              ✕
            </button>
            <div className="cpw-modal-preview">
              <FullPagePreview pageData={previewData} />
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

export default CreatePageWizard;